import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Spin } from 'antd';
import React,{ useRef, useState, useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import moment from 'moment/moment';
import {GlobalOutlined, MailOutlined} from '@ant-design/icons';


export const VideoGrattisList = () => {
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const statusArr = ["None","GenerationStarted", "Generated", "DeliveryStarted", "Delivered", "Error", "NotificationSent"];

  useEffect(() => {
    let jwttoken = sessionStorage.getItem("jwttoken");
    axios.get(`api/videograttis`,{ headers: { "Authorization": `bearer ${jwttoken}` } })
        .then(res => {
            setdata(res.data);
            setLoading(false);
        })
        .catch(error => {
            console.log(error);
        });
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const genLog = (logs) => {
    return (
      <>
        <Button size='small' style={{width:"50px"}} icon={<MailOutlined />}> {logs.length}</Button>
      </>
      )
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const columns = [

    {
      title: 'Date',
      dataIndex: 'raceDayDate',
      key: 'raceDayDate',
      width: '25%',
      className: 'nowrap',
      ...getColumnSearchProps('raceDayDate'),
      render: (record) => {
        return (moment(record).format("YYYY-MM-DD"))
      }
    },
    {
      title: 'Track',
      dataIndex: 'trackName',
      key: 'trackName',
      width: '20%',
      ...getColumnSearchProps('trackName'),
    },
    {
      title: 'Race',
      dataIndex: 'raceNr',
      key: 'raceNr',
      ...getColumnSearchProps('raceNr'),
      sorter: (a, b) => a.raceNr.length - b.raceNr.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Horse',
      dataIndex: 'horseName',
      key: 'horseName',
      width: '30%',
      ...getColumnSearchProps('horseName'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '20%',
      ...getColumnSearchProps('status'),
      render: (record) => {
        return (statusArr[record])
      }
    },
    {
      title: 'Link',
      dataIndex: 'shortLink',
      key: 'shortLink',
      width: '20%',
      render: (record) => {
        return (
          record ? <a href={record} target='_blank'><GlobalOutlined /></a> : ''
        )
      }
    },
    {
      title: '',
      dataIndex: 'recipients',
      key: 'recipients',
      width: '20%',
      render: (record) => {
        return (
          genLog(record)
        )
      }
    },
  ];

  let content = loading
        ? (<Spin tip="Loading" size="large">
            <div className="content" />
          </Spin>)
        : <Table columns={columns} dataSource={data} />

  return <Table columns={columns} dataSource={data} />;
};